import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from '../../../services/session'
import CONFIG_COMPANY from "../../../services/myConfig";

const AdminApiService = new AdminApi()


export default {
    data() {
        return {
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            model: {
                firstName: '',
                lastName: '',
                companyName: '',
                companyDisplayName: '',
                testUsername: '',
                usernameForShop: '',
                googlePlayUsername: '',
                logoUrl: '',
                superUsername: '',
                mainAdminUsername: '',
                adminEmail: '',
                brendedApp: false
            },
            androidVersion: 0,
            iosVersion: 0
        }

    },
    methods: {
        addCompany: addCompany,
        loadTextFromFile: loadTextFromFile,
        uploadPhoto: uploadPhoto,
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
    }
}

function uploadPhoto() {
    let _self = this;
    AdminApiService.uploadCompanyLogoImage(this.model.companyName, this.selectedImage)
        .then((response) => {
            _self.addCompany(response.data.url)
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}


function addCompany(url) {
    this.model.logoUrl = url;
    AdminApiService.addNewCompany(this.model)
        .then((response) => {
            swal('Success', 'Kompanija sacuvana', 'success')
            this.$router.push('/companies')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}



// WEBPACK FOOTER //
// ./src/components/Company/Add/AddCompany.js